import { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { FaGoogle } from 'react-icons/fa'; // Import Google icon

function Register() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [agreement, setAgreement] = useState(false);
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!agreement) {
      setMessage('You must agree to the Privacy Policy and Terms of Use.');
      return;
    }
    const res = await fetch(`${import.meta.env.VITE_API_URL}/api/auth/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email, password }),
    });
    const data = await res.json();
    if (res.ok) {
      // After registration, automatically log in the user by calling the login endpoint
      const loginRes = await fetch(`${import.meta.env.VITE_API_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const loginData = await loginRes.json();
      if (loginRes.ok) {
        login(loginData.token);
        navigate('/profile');
      } else {
        setMessage('Registration succeeded but automatic login failed.');
      }
    } else {
      setMessage(data.error);
    }
  };

  // Add Google registration handler
  const handleGoogleRegister = () => {
    // Redirect to the same backend endpoint as login; backend handles new vs existing user
    window.location.href = `${import.meta.env.VITE_API_URL}/api/auth/google`;
  };

  return (
    <div className="flex my-40 items-center justify-center">
      <div className="bg-white p-8 rounded-lg border border-grey-200 max-w-md w-full dark:bg-gray-900 dark:border-gray-700">
        <h1 className="text-3xl mb-6 text-center font-heading">Create an Account</h1>
        <form onSubmit={handleRegister} className="space-y-4 font-body">
          <input
            type="text"
            placeholder="Name"
            className="w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-600 dark:bg-gray-800 dark:border-gray-600 dark:text-white"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <input
            type="email"
            placeholder="Email"
            className="w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-600 dark:bg-gray-800 dark:border-gray-600 dark:text-white"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder="Password"
            className="w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-600 dark:bg-gray-800 dark:border-gray-600 dark:text-white"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <div className="flex items-center">
            <input
              type="checkbox"
              id="agreement"
              className="mr-2"
              checked={agreement}
              onChange={(e) => setAgreement(e.target.checked)}
            />
            <label htmlFor="agreement" className="text-sm text-black dark:text-white">
              I agree to the <Link to="/privacy-policy" className="font-medium hover:underline">Privacy Policy</Link> and <Link to="/terms-of-use" className="font-medium hover:underline">Terms of Use</Link>
            </label>
          </div>
          {message && <p className="mt-4 text-center text-red-500">{message}</p>}
          <button
            type="submit"
            className="bg-customGreen dark:bg-customGreen dark:text-black w-full py-3 bg-black text-white rounded-md hover:bg-customGreen/90 dark:hover:bg-customGreen/90 transition"
          >
            Register with Email
          </button>
        </form>

        {/* Divider */}
        <div className="my-6 flex items-center justify-center">
          <span className="border-t border-gray-300 flex-grow"></span>
          <span className="mx-4 text-gray-500 text-sm dark:text-gray-400">OR</span>
          <span className="border-t border-gray-300 flex-grow"></span>
        </div>

        {/* Google Register Button */}
        <button
          onClick={handleGoogleRegister}
          className="w-full py-3 bg-white border border-gray-300 text-gray-700 rounded-md transition flex items-center justify-center hover:bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
        >
          <FaGoogle className="mr-2" />
          Continue with Google
        </button>

        <p className="mt-6 text-center font-body text-black dark:text-white">
          Already have an account?{' '}
          <Link to="/login" className="font-semibold hover:underline dark:text-white">
            Login here
          </Link>
        </p>
      </div>
    </div>
  );
}

export default Register;
